<template>
	<div class="product-box" @click="getProductGetUrl(item)">
		<div class="product-photo scale">
			<div class="photo-inner">
				<el-image :src="item.img" lazy></el-image>
			</div>
		</div>
		<div class="product-grid">
			<div class="product-title ">
				<div class="title-span ellipsis">
					{{item.title}}
				</div>
			</div>
			<div class="product-delete-price">{{formatNumber(item.y_price)}}VND</div>
			<div class="product-price layui-text-orange">{{formatNumber(item.price)}}VND</div>
			<div class="product-attr" v-if="isItemBar">
				<div class="attr-number">{{$t("人付款")}} {{item.sell_count}}</div>
				<div class="attr-item">
					<!-- <span class="iconfont icon-cart"></span> -->
					<span class="iconfont"
						:class="item.is_collect?'icon-collect active':'icon-collect-solid'"
						@click.stop="toggleCollect(item)"></span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		user_set_favorites_api,
		goods_addCart_api
	} from "@/api/index"
	export default {
		props: {
			item: {
				default: () => ({}),
			},
			isItemBar:{
				type:Boolean,
				default:true,
			}
		},
		data() {
			return {};
		},
		computed: {},
		methods: {
			async toggleCollect(product) {
				if(!this.$store.state.isLoginStatu){
					this.goUrl('/login')
					return false
				}
				let data = {
					id: product.id,
				};
				product.is_collect = !product.is_collect;
				if (product.is_collect) {
					this.successTips('收藏成功');
				} else {
					this.errorTips('取消收藏');
				}
				await user_set_favorites_api(data).then(res => {
					if (res && res.data.code == 1) {
						console.log(res.data.msg)
					}
				});
			},
			getProductGetUrl(item) {
				if (item.gid) {
					this.$router.push({
						path: '/product-detail',
						query: {
							id: item.gid
						}
					});
				} else if (item.id) {
					// 如果 item.gid 不存在，再判断 item.id
					this.$router.push({
						path: '/product-detail',
						query: {
							id: item.id
						}
					});
				}
			},
		},
		mounted() {}
	}
</script>